import * as types from "../../actions/signedInUserSegments/types";
import * as userSegmentTypes from "../../actions/userSegment/types";

const initialState = {
  hasFetchError: false,
  isFetching: false,
  isLoaded: false,
  list: [],
  page: 0,
  pageCount: 0,
};

export default function signedInUserSegments(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_SIGNED_IN_USER_SEGMENTS_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true,
        hasFetchError: false,
      });
    }
    case types.FETCH_SIGNED_IN_USER_SEGMENTS_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        hasFetchError: false,
        isLoaded: true,
        list: action.userSegments,
        page: action.page,
        pageCount: action.pageCount,
      });
    }
    case types.FETCH_SIGNED_IN_USER_SEGMENTS_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false,
        isLoaded: false,
        hasFetchError: true,
      });
    }
    case userSegmentTypes.DELETE_USER_SEGMENT_SUCCESS: {
      return Object.assign({}, state, {
        list: state.list.filter(
          userSegment => userSegment.id !== action.userSegmentId
        ),
      });
    }
    case userSegmentTypes.DUPLICATE_USER_SEGMENT_SUCCESS: {
      const indexOfOriginal = state.list.findIndex(
        userSegment => userSegment.id === action.originalId
      );

      if (indexOfOriginal < 0) {
        return state;
      }

      // Insert after the duplicated item
      const newList = [...state.list];
      newList.splice(indexOfOriginal + 1, 0, action.userSegment);

      return Object.assign({}, state, { list: newList });
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/signedInUserSegments/index.js